import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export function StickyCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > window.innerHeight);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-147">
      {visible && <motion.div initial={{
      opacity: 0,
      y: 16,
      scale: 0.95
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 16,
      scale: 0.95
    }} transition={{
      duration: 0.3,
      ease: [0.16, 1, 0.3, 1]
    }} className="fixed bottom-[28px] right-[28px] z-[200]" data-id="element-148">
          <a href="mailto:hello@vaultlab.agency" className="block bg-tux-lime text-tux-dark font-mono text-[10px] tracking-[0.22em] uppercase px-[24px] py-[12px] no-underline shadow-[0_8px_32px_rgba(200,255,0,0.18)] transition-colors duration-150 hover:bg-[#d4ff1a]" data-id="element-149">
            Brief Us
          </a>
        </motion.div>}
    </AnimatePresence>;
}